import React from 'react';
import { View } from 'react-native';
import Text from '../../../components/text/Text';
import { useThemedStyles } from '../../../hooks/useThemedStyles';

const SetupInfoRow = ({ label, value }) => {
	const styles = useThemedStyles(createStyles);

	return (
		<View style={styles.row}>
			<Text style={styles.label}>{label}</Text>
			<Text style={styles.value}>{value || 'Not set'}</Text>
		</View>
	);
};

const createStyles = ({ ui: { colors, type, space } }) => ({
	row: {
		marginBottom: space.md,
		gap: space.xxs,
	},
	label: {
		...type.overline,
		letterSpacing: 0.48,
		color: colors.textSecondary,
		textTransform: 'uppercase',
	},
	value: {
		...type.rowText,
		color: colors.text,
	},
});

export default SetupInfoRow;
